import { List } from 'immutable';
import { managementFeeConstants } from '../constants';

export function management_fees(state = {}, action) {
  switch (action.type) {
    case managementFeeConstants.MANAGEMENT_FEE_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case managementFeeConstants.MANAGEMENT_FEE_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case managementFeeConstants.MANAGEMENT_FEE_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };

    case managementFeeConstants.MANAGEMENT_FEE_LIST_CLEAR:
      return {
        ...state,
        items: null
      };

    case managementFeeConstants.MANAGEMENT_FEE_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case managementFeeConstants.MANAGEMENT_FEE_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case managementFeeConstants.MANAGEMENT_FEE_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case managementFeeConstants.MANAGEMENT_FEE_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case managementFeeConstants.MANAGEMENT_FEE_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const managementFeeIndex = state.items.findIndex(val => val.id == action.response.id);

      if (managementFeeIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(managementFeeIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case managementFeeConstants.MANAGEMENT_FEE_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case managementFeeConstants.MANAGEMENT_FEE_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case managementFeeConstants.MANAGEMENT_FEE_DELETE_SUCCESS: {
      const managementFeeId = action.feeId;

      if (!state.items) {
        return state;
      }

      const managementFeeIndex = state.items.findIndex(val => val.id == managementFeeId);

      if (managementFeeIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(managementFeeIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case managementFeeConstants.MANAGEMENT_FEE_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };

    case managementFeeConstants.MANAGEMENT_FEE_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    case managementFeeConstants.MANAGEMENT_FEE_SYNC_LOADING:
      return {
        ...state,
        syncLoading: true,
        syncError: null
      };
    case managementFeeConstants.MANAGEMENT_FEE_SYNC_SUCCESS:
      return {
        ...state,
        syncLoading: false,
        syncError: null
      };
    case managementFeeConstants.MANAGEMENT_FEE_SYNC_FAILURE:
      return {
        ...state,
        syncLoading: false,
        syncError: action.error
      };
    default:
      return state;
  }
}
